"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringHandler = void 0;
var HandlerMapping_1 = require("../handler/HandlerMapping");
function stringHandler(data, options) {
    if (options === void 0) { options = { leaveLetters: 0 }; }
    var _a = options.leaveLetters, leaveLetters = _a === void 0 ? 0 : _a;
    if (typeof data !== 'string') {
        return HandlerMapping_1.HandlerMapping.handlersMapping.default();
    }
    // We are always hiding at least as many letters as leaving
    var deleteLetters = data.length - leaveLetters >= leaveLetters
        ? data.length - leaveLetters
        : data.length - (data.length - leaveLetters);
    leaveLetters = data.length - deleteLetters; // Adjust leaveLetters to fit new amount of deleteLetters
    var dataToRedact = data.substring(leaveLetters);
    return data.substring(0, leaveLetters) + dataToRedact.replace(/[^\s]/g, '*');
}
exports.stringHandler = stringHandler;
//# sourceMappingURL=stringHandler.js.map